export * from './UIGameResourceCardsTooltipContent.tsx';
